import script from "./DataMapEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./DataMapEditor.vue?vue&type=script&setup=true&lang=js"

import "./DataMapEditor.vue?vue&type=style&index=0&id=4eb01645&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eb01645"]])

export default __exports__